import Palette from './Palette'
import StructuralElement from '../../chem/StructuralElement'

const palette = new Palette('VMD', 'VM')

palette.colors = [
  /* eslint-disable no-magic-numbers */
  0x0000ff, // blue
  0xff0000, // red
  0x606060, // gray
  0xff8000, // orange
  0xffff00, // yellow
  0x808033, // tan
  0x999999, // silver
  0x00ff00, // green
  0xffffff, // white
  0xff9999, // pink
  0x40c0c0, // cyan
  0xa600a6, // purple
  0x80e666, // lime
  0xe666b3, // mauve
  0x804d00, // ochre
  0x8080c0 // ice blue
  /* eslint-enable no-magic-numbers */
]

palette.defaultElementColor = 0x804d00

// DO NOT EDIT MANUALLY! Autogenerated from atom_types.csv by atom_types.py.
palette.elementColors = {
  /* eslint-disable no-magic-numbers */
  H: 0xffffff,
  C: 0x40bfbf,
  N: 0x0000ff,
  O: 0xff0000,
  P: 0x808033,
  S: 0xffff00
  /* eslint-enable no-magic-numbers */
}

palette.defaultResidueColor = 0x40c0c0

// DO NOT EDIT MANUALLY! Autogenerated from residue_types.csv by residue_types.py.
palette.residueColors = {
  /* eslint-disable no-magic-numbers */
  ALA: 0x0000ff,
  ARG: 0xffffff,
  ASN: 0x808033,
  ASP: 0xff0000,
  CYS: 0xffff00,
  GLN: 0xff8000,
  GLU: 0xff9999,
  GLY: 0xffffff,
  HIS: 0x40c0c0,
  ILE: 0x00ff00,
  LEU: 0xff9999,
  LYS: 0x40c0c0,
  MET: 0xffff00,
  PHE: 0xa600a6,
  PRO: 0x804c00,
  SER: 0xffff00,
  THR: 0xe666b3,
  TRP: 0x999999,
  TYR: 0x00ff00,
  VAL: 0x808033,
  A: 0x0000ff,
  C: 0xff8000,
  G: 0xffff00,
  T: 0xa600a6,
  U: 0x00ff00,
  DA: 0x0000ff,
  DC: 0xff8000,
  DG: 0xffff00,
  DT: 0xa600a6,
  DU: 0x00ff00,
  '+A': 0x0000ff,
  '+C': 0xff8000,
  '+G': 0xffff00,
  '+T': 0xa600a6,
  '+U': 0x00ff00,
  WAT: 0x40c0c0,
  H2O: 0x40c0c0,
  HOH: 0x40c0c0
  /* eslint-enable no-magic-numbers */
}

palette.chainColors = [0xffffff].concat(palette.colors)

const StructuralElementType = StructuralElement.Type

palette.secondaryColors = {
  [StructuralElementType.HELIX_ALPHA]: 0xa600a6,
  [StructuralElementType.HELIX_310]: 0x0000ff,
  [StructuralElementType.HELIX_PI]: 0xff0000,
  [StructuralElementType.STRAND]: 0xffff00,
  [StructuralElementType.BRIDGE]: 0x808033,
  [StructuralElementType.TURN]: 0x40c0c0
}

export default palette
